import { MemoizedSelector, createSelector } from '@ngrx/store';
import { ClientToken, StateUtils } from '@spartacus/core';
import { ClientAuthState, StateWithClientAuth } from '../client-auth-state';
import { getClientAuthState } from './feature.selector';

export const getClientTokenState: MemoizedSelector<StateWithClientAuth, StateUtils.LoaderState<ClientToken>> = createSelector(
  getClientAuthState,
  (state: ClientAuthState) => state.clientToken
);
